import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import logoImg from '../assets/blast-logo.webp';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3301/api';

export default function PublicHistory() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);
  const [previewRecap, setPreviewRecap] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE}/touring-events/`)
      .then((res) => setEvents(res.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ background: '#12151A', color: '#F0EDE4', minHeight: '100vh', fontFamily: "'Segoe UI', sans-serif" }}>
      <nav style={{ padding: '18px 6vw', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <img src={logoImg} alt="Blast Motor Club" style={{ height: 36, width: 'auto' }} />
        <Link to="/" style={{ color: '#D02127', fontSize: 13, textDecoration: 'none' }}>← Beranda</Link>
      </nav>

      <div style={{ padding: '0 6vw 60px', maxWidth: 800, margin: '0 auto' }}>
        <span style={{ color: '#D02127', fontWeight: 800, fontSize: 12, letterSpacing: 3, textTransform: 'uppercase' }}>
          Touring
        </span>
        <h1 style={{ fontSize: 'clamp(24px, 4vw, 36px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 30px' }}>
          Semua Riwayat Touring
        </h1>

        {loading ? (
          <p style={{ color: '#8B92A0' }}>Memuat...</p>
        ) : events.length === 0 ? (
          <p style={{ color: '#8B92A0' }}>Belum ada touring.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {events.map((ev) => (
              <div key={ev.id} style={{
                background: 'linear-gradient(120deg, #1C2128 0%, #171b21 100%)',
                padding: 22, clipPath: 'polygon(0 0, 96% 0, 100% 100%, 4% 100%)',
                border: '1px solid #262b33',
              }}>
                <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
                  {ev.status === 'ongoing' && (
                    <span style={{ background: 'rgba(208,33,39,0.2)', color: '#D02127', fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 4 }}>
                      🔴 LIVE
                    </span>
                  )}
                  {ev.status === 'selesai' && (
                    <span style={{ background: 'rgba(74,222,128,0.15)', color: '#4ADE80', fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 4 }}>
                      SELESAI
                    </span>
                  )}
                  <span style={{
                    background: ev.tipe === 'santai' ? 'rgba(139,146,160,0.2)' : 'rgba(43,105,150,0.2)',
                    color: ev.tipe === 'santai' ? '#8B92A0' : '#2B6996',
                    fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 4,
                  }}>
                    {ev.tipe === 'santai' ? 'TOURING SANTAI' : 'TOURING RESMI'}
                  </span>
                </div>
                <p style={{ fontWeight: 800, fontSize: 17 }}>{ev.title}</p>
                {ev.location && <p style={{ color: '#8B92A0', fontSize: 13, marginTop: 6 }}>📍 {ev.location}</p>}
                <p style={{ color: '#8B92A0', fontSize: 13, marginTop: 4 }}>
                  📅 {new Date(ev.tanggal_mulai).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}
                </p>
                <p style={{ color: '#8B92A0', fontSize: 13, marginTop: 4 }}>
                  👤 Dibuat oleh: {ev.creator_name}
                </p>
                <button
                  onClick={() => setExpandedId(expandedId === ev.id ? null : ev.id)}
                  style={{ background: 'transparent', border: 'none', color: '#2B6996', fontSize: 12, fontWeight: 700, cursor: 'pointer', padding: 0, marginTop: 8 }}
                >
                  👥 {ev.participant_count} peserta {expandedId === ev.id ? '▲' : '▼'}
                </button>
                {expandedId === ev.id && (
                  <div style={{ marginTop: 8, padding: '10px 14px', background: '#12151A', borderRadius: 6 }}>
                    {ev.participant_names.length === 0 ? (
                      <p style={{ color: '#5a616e', fontSize: 12 }}>Belum ada peserta.</p>
                    ) : (
                      <p style={{ color: '#c8ccd3', fontSize: 12, lineHeight: 1.8 }}>{ev.participant_names.join(', ')}</p>
                    )}
                  </div>
                )}
                {ev.status === 'selesai' && (
                  <button
                    onClick={() => setPreviewRecap(ev.id)}
                    style={{ display: 'inline-block', marginTop: 10, background: 'transparent', border: 'none', color: '#2B6996', fontSize: 12, fontWeight: 700, cursor: 'pointer', padding: 0 }}
                  >
                    → Lihat Kartu Rekap
                  </button>
                )}
                {ev.status === 'selesai' && (
                  <a
                    href={`${API_BASE}/recap/${ev.id}/pdf`}
                    style={{ display: 'inline-block', marginTop: 10, marginLeft: 16, color: '#8B92A0', fontSize: 12, fontWeight: 700, textDecoration: 'none' }}
                  >
                    → Unduh PDF Rekap
                  </a>
                )}
                {ev.status === 'ongoing' && (
                  <Link
                    to={`/live-touring/${ev.id}`}
                    style={{ display: 'inline-block', marginTop: 10, color: '#D02127', fontSize: 12, fontWeight: 700, textDecoration: 'none' }}
                  >
                    → Lihat Live
                  </Link>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {previewRecap && (
        <div
          onClick={() => setPreviewRecap(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', zIndex: 100,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 20,
          }}
        >
          <img
            src={`${API_BASE}/recap/${previewRecap}/card`}
            alt=""
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: '100%', maxHeight: '75vh', borderRadius: 8, objectFit: 'contain' }}
          />
          <div style={{ display: 'flex', gap: 12, marginTop: 20 }} onClick={(e) => e.stopPropagation()}>
            <a
              href={`${API_BASE}/recap/${previewRecap}/card`}
              download
              style={{ background: '#D02127', color: '#fff', padding: '10px 22px', borderRadius: 6, fontSize: 14, fontWeight: 700, textDecoration: 'none' }}
            >
              ⬇ Unduh
            </a>
            <button
              onClick={() => setPreviewRecap(null)}
              style={{ background: 'transparent', border: '1px solid #262b33', color: '#F0EDE4', padding: '10px 22px', borderRadius: 6, fontSize: 14, cursor: 'pointer' }}
            >
              Tutup
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
